import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UrlService {

    public combineUri(...uris): string {
        return uris.join('/') + '/';
    }
}
